import { mapGetters } from 'vuex';
import { initializeAudioAlerts } from '../helper/scriptHelpers';
export const DEFAULT_CONVERSATION_SIDEBAR_ITEMS_ORDER = [
  { name: 'conversation_actions' },
  { name: 'macros' },
  { name: 'conversation_info' },
  { name: 'contact_attributes' },
  { name: 'ticket_attributes' },
  { name: 'previous_conversation' },
  { name: 'conversation_participants' },
  { name: 'conversation_files' },
];
export const DEFAULT_CONTACT_SIDEBAR_ITEMS_ORDER = [
  { name: 'contact_attributes' },
  { name: 'contact_labels' },
  { name: 'previous_conversation' },
];

export const CONVERSATION_LIST_TAB_GROUPS = {
  OWNERSHIP: 'ownershipOptions',
  STATUS: 'statusOptions',
};

export const DEFAULT_OWNERSHIP_TABS_ORDER = [
  { key: 'me', visible: true },
  { key: 'unassigned', visible: true },
  { key: 'all', visible: true },
  { key: 'new', visible: true },
];

export const DEFAULT_STATUS_TABS_ORDER = [
  { key: '!resolved', visible: true },
  { key: 'resolved', visible: true },
  { key: 'pending', visible: true },
  { key: 'snoozed', visible: true },
  { key: 'all', visible: true },
];

const mergeTabsOrder = (savedOrder, defaultOrder) => {
  const order = savedOrder ? [...savedOrder] : [];
  defaultOrder.forEach(item => {
    if (!order.find(i => i.key === item.key)) {
      order.push({ ...item });
    }
  });
  return order;
};

export const isEditorHotKeyEnabled = (uiSettings, key) => {
  const {
    editor_message_key: editorMessageKey,
    enter_to_send_enabled: enterToSendEnabled,
  } = uiSettings || {};
  if (!editorMessageKey) {
    if (enterToSendEnabled) {
      return key === 'enter';
    }
    return key === 'cmd_enter';
  }
  return editorMessageKey === key;
};

const symDifference = (arr1, arr2) => {
  return arr1
    .filter(x => !arr2.includes(x))
    .concat(arr2.filter(x => !arr1.includes(x)));
};

export default {
  computed: {
    ...mapGetters({ uiSettings: 'getUISettings' }),
    conversationSidebarItemsOrder() {
      const { conversation_sidebar_items_order: itemsOrder } = this.uiSettings;
      // If the sidebar order is not set, use the default order.
      if (!itemsOrder) {
        return DEFAULT_CONVERSATION_SIDEBAR_ITEMS_ORDER;
      }
      // If the sidebar order doesn't have the new elements, then add them to the list.
      DEFAULT_CONVERSATION_SIDEBAR_ITEMS_ORDER.forEach(item => {
        if (!itemsOrder.find(i => i.name === item.name)) {
          itemsOrder.push(item);
        }
      });
      return itemsOrder;
    },
    contactSidebarItemsOrder() {
      const { contact_sidebar_items_order: itemsOrder } = this.uiSettings;
      return itemsOrder || DEFAULT_CONTACT_SIDEBAR_ITEMS_ORDER;
    },
    conversationListTabGroup() {
      return (
        this.uiSettings.conversation_list_tab_group ||
        CONVERSATION_LIST_TAB_GROUPS.OWNERSHIP
      );
    },
    ownershipTabsOrder() {
      return mergeTabsOrder(
        this.uiSettings.conversation_list_ownership_tabs,
        DEFAULT_OWNERSHIP_TABS_ORDER
      );
    },
    statusTabsOrder() {
      return mergeTabsOrder(
        this.uiSettings.conversation_list_status_tabs,
        DEFAULT_STATUS_TABS_ORDER
      );
    },
  },
  methods: {
    updateUISettings(uiSettings = {}) {
      const uiSettingsData = {
        ...this.uiSettings,
        ...uiSettings,
      };
      const user = this.$store.getters.getCurrentUser;
      initializeAudioAlerts({
        ui_settings: uiSettingsData,
        id: user.id,
        sound_settings: user.sound_settings,
      });
      this.$store.dispatch('updateUISettings', {
        uiSettings: uiSettingsData,
      });
    },
    isContactSidebarItemOpen(key) {
      const { [key]: isOpen } = this.uiSettings;
      return !!isOpen;
    },
    toggleSidebarUIState(key) {
      this.updateUISettings({ [key]: !this.isContactSidebarItemOpen(key) });
    },
    syncPinnedConversations(id) {
      const conversations = symDifference(
        this.uiSettings.pinnedConversations || [],
        [id]
      );
      this.updateUISettings({
        pinnedConversations: conversations,
      });
    },
    updateConversationListTabGroup(group) {
      this.updateUISettings({ conversation_list_tab_group: group });
    },
    updateConversationListTabsOrder(group, order) {
      const key =
        group === CONVERSATION_LIST_TAB_GROUPS.STATUS
          ? 'conversation_list_status_tabs'
          : 'conversation_list_ownership_tabs';
      this.updateUISettings({ [key]: order });
    },
  },
};
